module.exports = __webpack_public_path__ + "img/10.5c4e8a78.jpg";